export const DEFAULT_COLOR = { r: 66, g: 13, b: 171 };
export const DEFAULT_WIDTH = 33;
export enum Color {
    RED = "RED", 
    GREEN = "GREEN", 
    BLUE = "BLUE"
}